import queryString from 'query-string'
import StandaloneAdapter from './standaloneAdapter'
import FakeAdapter from './fakeAdapter'
import JiraAdapter from './jiraAdapter'

export const getHostAdapter = () => {
  const parsed = queryString.parse(window.location.search)
  if (typeof parsed.mode === 'undefined') {
    return new StandaloneAdapter()
  }
  if (typeof AP === 'undefined') {
    return new FakeAdapter()
  }
  return new JiraAdapter()
}
